import { BASE_URL } from 'src/components/10-atoms/seo/constants';
import { parseLimit, parseOffset } from 'src/utils/pagination/listPagination';
function toAbsolutePageHref(path) {
    if (/^https?:\/\//.test(path)) {
        return path;
    }
    return `${BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
export function getListPageMetaLinks(buildPageHref, offset, limit, hasMore) {
    const currentOffset = parseOffset(offset);
    const pageLimit = parseLimit(limit);
    const prevOffset = Math.max(0, currentOffset - pageLimit);
    return {
        prevPageHref: currentOffset > 0
            ? toAbsolutePageHref(buildPageHref(prevOffset))
            : undefined,
        nextPageHref: hasMore
            ? toAbsolutePageHref(buildPageHref(currentOffset + pageLimit))
            : undefined,
    };
}
